import { NEW_BASE_URL } from "../../Constant";
import { newReconServiceAPI } from "../APIutils";

export function userLogout() {
  const url = `${NEW_BASE_URL}/v1/auth/logout`;
  return newReconServiceAPI(url, {}, true);
}
